/* istanbul ignore file */
import { AppId, createEntityManagementRoutes } from '@lumapps/router';

const {
    baseRoute: userDirectoriesRoute,
    editRoute: userDirectoryEditRoute,
    createRoute: userDirectoryCreateRoute,
    getBaseRoute: userDirectories,
    getEditRoute: userDirectoryEdit,
    getCreateRoute: userDirectoryCreate,
} = createEntityManagementRoutes({
    slug: 'user-directories',
    appId: AppId.backOffice,
});

export {
    userDirectories,
    userDirectoriesRoute,
    userDirectoryCreate,
    userDirectoryEdit,
    userDirectoryEditRoute,
    userDirectoryCreateRoute,
};
